import React, { useContext, useState } from 'react';
import { DataContext } from '../../context/DataContext';
import Modal from 'react-modal';

import DivRow from '../controls/DivRow';
import DropDownInput from '../controls/DropDownInput';

import Input from '../controls/Input';
import InputSelect from '../controls/InputSelect';
import { declaracionSalud, declaracionSaludEje, goodBye } from '../../data/texts';
import { ImgAlert } from '../../svg';
import { amaDeCasa, estudiante } from '../../utils/constanst';


const Step2 = () => {

    const [isOpen, setIsOpen] = useState(false);

    const closeModal = () => {
        setIsOpen(false);
    }

    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
      };

    const { poliza, changeHandler } = useContext(DataContext);

    return (
        <div className="reponsive">
            <div className="reponsive-width-6">
                <div className='box-pl2-pr2'>
                    <InputSelect containBlank={true} label='Actividad Economica' field='actividad' value={poliza.actividad} onChange={changeHandler} dataProvider='entities/0/economicActivities' />
                    <Input label='Empresa donde trabaja' field='empresaTrabaja' value={poliza.empresaTrabaja} onChange={changeHandler} required={poliza.actividad !== amaDeCasa && poliza.actividad!==estudiante} />
                    <Input label='Telefono de empresa'  type='maskInput' mask='9999-9999' field='telefono' placeholder='0000-0000' value={poliza.telefono} onChange={changeHandler} required={poliza.actividad !== amaDeCasa && poliza.actividad!==estudiante}/>
                </div>
            </div>
            <div className="reponsive-width-6">  
                <div className='box-pl2-pr2'>
                    <InputSelect label='Ocupacion'  field='ocupacion' value={poliza.ocupacion} onChange={changeHandler} dataProvider='ocupacion' readOnly={true} />
                    <DropDownInput label='Ingreso Mensual' dataProvider='monedas' 
                            value={poliza.ingresoMensual} onChange={changeHandler}
                            valueSelect={poliza.ingresoMoneda} onChangeSelect={changeHandler}
                            field='ingresoMensual' 
                            fieldSelect='ingresoMoneda'          
                            type='number'              
                        />
                    <InputSelect label='Origen de fondo' field='origenFondo' value={poliza.origenFondo} onChange={changeHandler}  dataProvider='origenFondo' />
                    {
                        poliza.origenFondo === '1' &&
                        <Input type='textarea' label='Explique el origen de fondo'  field='origenFondoOtros' value={poliza.origenFondoOtros} onChange={changeHandler} />
                    }
                </div>
            </div>
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
            >
                <h2 className="txt-primary">{declaracionSalud}</h2>
                <div className="dialog-center-content">
                    <ImgAlert />
                </div>
                <h5 className="txt-muted">{declaracionSaludEje}</h5>
                <h5 className="txt-primary">{goodBye}</h5>
                <div className="dialog-center-content">
                    <button type="button" className="control-button-btn btn-color-primary" onClick={closeModal}>Entendido</button>
                </div>
            </Modal>
        </div>
    );
}

export default Step2;
